
import axios from 'axios';

// Helper to get the correct base URL
const getBaseURL = () => {
    const envUrl = process.env.REACT_APP_API_URL;

    // If we're in development and the current window is not localhost,
    // we should use the current window's hostname for the API
    if (envUrl && envUrl.includes('localhost') && window.location.hostname !== 'localhost') {
        return envUrl.replace('localhost', window.location.hostname);
    }

    return envUrl || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');
};

const api = axios.create({
    baseURL: getBaseURL(),
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to attach the token if it exists
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle auth errors globally
        if (error.response && error.response.status === 401) {
            // Clear invalid/expired token
            localStorage.removeItem('token');

            // Only redirect to login if we're not already there
            const currentPath = window.location.pathname;
            if (currentPath !== '/login' && currentPath !== '/') {
                console.warn('Authentication expired. Please log in again.');
                // Optionally redirect to login
                // window.location.href = '/login';
            }
        }

        // Log errors in development
        if (process.env.NODE_ENV === 'development') {
            console.error('API Error:', error.response?.data || error.message);
        }

        return Promise.reject(error);
    }
);

export default api;
